export default __webpack_public_path__ + "static/media/no-result.ec22e94c.svg";